/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateTeammateInviteCommandDto interface.
 */
export function instanceOfCreateTeammateInviteCommandDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('companyIds' in value) || value['companyIds'] === undefined)
        return false;
    return true;
}
export function CreateTeammateInviteCommandDtoFromJSON(json) {
    return CreateTeammateInviteCommandDtoFromJSONTyped(json, false);
}
export function CreateTeammateInviteCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'companyIds': json['companyIds'],
    };
}
export function CreateTeammateInviteCommandDtoToJSON(json) {
    return CreateTeammateInviteCommandDtoToJSONTyped(json, false);
}
export function CreateTeammateInviteCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'companyIds': value['companyIds'],
    };
}
